import { createAction, createSlice } from "@reduxjs/toolkit";

export const fetchWorkflowCatalogRequest = createAction("workflowCatalog/fetchWorkflowCatalogRequest");

const initialState = {
  data: null,
  loading: false,
  error: null,
  lastUpdated: null
};

const workflowCatalogSlice = createSlice({
  name: "workflowCatalog",
  initialState,
  reducers: {
    fetchWorkflowCatalogStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchWorkflowCatalogSuccess(state, action) {
      state.loading = false;
      let data = action.payload;
      if (data && Array.isArray(data.actions)) {
        data = {
          ...data,
          actions: data.actions.map(act => {
            if (act.type === "HTTP_REQUEST") {
              return {
                ...act,
                inputSchema: {
                  ...act.inputSchema,
                  params: { type: "keyvalue", label: "Query Parameters" }
                }
              };
            }
            if (act.type === "SET_VARIABLE") {
              return {
                ...act,
                inputSchema: {
                  variables: { type: "keyvalue", label: "Variables" }
                }
              };
            }
            if (act.type === "CLEAR_VARIABLE") {
              return {
                ...act,
                inputSchema: {
                  variables: { type: "keyvalue", label: "Variables to Clear", keyOnly: true }
                }
              };
            }
            return act;
          })
        };
      }
      state.data = data;
      state.error = null;
      state.lastUpdated = Date.now();
    },
    fetchWorkflowCatalogFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetWorkflowCatalog(state) {
      state.lastUpdated = null;
    }
  }
});

export const {
  fetchWorkflowCatalogStart,
  fetchWorkflowCatalogSuccess,
  fetchWorkflowCatalogFailure,
  resetWorkflowCatalog
} = workflowCatalogSlice.actions;

export default workflowCatalogSlice.reducer;
